import common from './common-educabot'

export default {
  ...common.button,
  color: `#2A205E`,
  '::before': {
    display: `none`
  },
  '::after': {
    ...common.button['::after'],
    bg: `white`,
    border: '0.5px solid',
    borderColor: `#2A205E`
  }
}